(function() {
    var steps = $('.steps__title');
    var stepsOptions = $('.stepOptions__option');
    var additionalFilters = $('.additionalFilters__title');
    var additionalFiltersOption = $('.additionalFilters__option');
    let locales = getLang();

    steps.on('click', switchStep);
    stepsOptions.on('click', selectOption);
    additionalFiltersOption.on('click', selectAdditionalOption);
    additionalFilters.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var additionalFiltersOptions = $(this).parent().find('.additionalFilters__options');
        var isCurrentOptionsBoxHidden = additionalFiltersOptions.hasClass('--hidden');
        $('.additionalFilters .additionalFilters__options').addClass('--hidden');
        if (isCurrentOptionsBoxHidden) {
            additionalFiltersOptions.removeClass('--hidden');
        } else {
            additionalFiltersOptions.addClass('--hidden');
        }
    });
    $('.stepOptions__series-details-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.stepOptions__series-details').toggleClass('--hidden');
        $('.stepOptions__series-details-toggle i').toggleClass('fa-caret-up');
    });

    $('.products__loadMoreProducts').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        filterProducts(true);
    });

    $('.productTile__doorColorOption').click(function() {
        var date = new Date();
        date.setTime(date.getTime() + 3600);
        var colorId = $(this).attr('data-color-id');
        var configId = $(this).attr('data-config-id');

        $('#config' + configId).css('background-color', $(this).css('background-color'));

        if ($(this).hasClass('selected')) {
            Cookies.remove(`default_config_color_${configId}`, {
                path: '/'
            });
            $(this).removeClass('selected');
        } else {
            Cookies.set(`default_config_color_${configId}`, colorId, {
                path: '/'
            });
            $('.productTile__doorColorOption').removeClass('selected');
            $(this).addClass('selected');
        }
    });


    function switchStep() {
        event.preventDefault();
        $('.steps__title').removeClass('--selected');
        $('.stepOptions__wrapper').addClass('--hidden');

        $(this).addClass('--selected');
        $('.stepOptions__wrapper[data-parent-step-id="' + $(this).data('stepId') + '"]').removeClass('--hidden');
    }

    function selectOption(e) {
        e.preventDefault();
        if ($(this).hasClass('--selected')) {
            $(this).removeClass('--selected');
        } else {
            const type = $(this).data('type');
            $('[data-type="' + type + '"]').removeClass('--selected');
            $(this).addClass('--selected');
        }
        resetAllNextOptions($(this));
        filterProducts(false, false)
    }

    function selectAdditionalOption() {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().find('.--selected').removeClass('--selected');
        $(this).addClass('--selected');
        filterProducts(false)
    }

    // in main steps we want to reset next steps after choose the previous one
    // and also we want to reset additional filters
    function resetAllNextOptions(selectedOption) {
        var currentStep = selectedOption.parent().data('parentStepId');
        var allSteps = $('[data-parent-step-id]');

        $.each(allSteps, function(index, step) {
            if ($(step).data('parentStepId') > currentStep) {
                $(step).find('.--selected').removeClass('--selected');
            }
        });

        $('.additionalFilters__option').removeClass('--selected');
    }

    function filterProducts(loadMore) {

        var params = getParamsValues(loadMore);
        var url = buildUrl(params);
        var headers = { 'filterRequest': true };

        if (loadMore) {
            headers.loadMore = true;
            $('.products__loadMoreProductsTitle').hide();
            $('.products__loadMoreProductsReloadIcon').addClass('--active');
            $.ajax({
                url: '/' + locales.SHOP_NOW_URL + url,
                headers: headers,
                success: function(response) {
                    if (loadMore) {
                        $(".search-pagination").remove();
                        $(".products__container").append(response.products);
                        if (response.hasMoreProducts) {
                            $('.products__loadMoreProducts').removeClass('--hidden');
                        } else {
                            $('.products__loadMoreProducts').addClass('--hidden');
                        }
                        observer.observe();
                        $('.products__loadMoreProductsTitle').show();
                        $('.products__loadMoreProductsReloadIcon').removeClass('--active');
                        return true;
                    }
                }
            });
        } else {
            document.location.assign('/' + locales.SHOP_NOW_URL + url);
        }
    }

    function getParamsValues(loadMore) {
        // we divide parameters into two groups: basic (used for pretty urls) and additional (used for query params, sorting)
        // we dont want index urls with additional params
        var params = { main: {}, additional: {} };
        var currentPage = $('.products__container').data('page');

        var selectedCategory = $('.--selected[data-type="category"]');
        var selectedMaterial = $('.--selected[data-type="material"]');
        var selectedType = $('.--selected[data-type="type"]');
        var selectedSerie = $('.--selected[data-type="serie"]');

        var selectedGlass = $('.--selected[data-type="glass"]');
        var selectedFactory = $('.--selected[data-type="factory"]');

        var sort = $('.--selected[data-type="sort"]');

        selectedCategory.length > 0 ? params.main.category = selectedCategory.data('slug') : false;
        selectedMaterial.length > 0 ? params.main.material = selectedMaterial.data('slug') : false;
        selectedType.length > 0 ? params.main.type = selectedType.data('slug') : false;
        selectedSerie.length > 0 ? params.additional.serier = selectedSerie.data('slug') : false;

        selectedGlass.length > 0 && selectedGlass.data('slug') !== '' ? params.main.glass = selectedGlass.data('slug') : false;
        selectedFactory.length > 0 && selectedFactory.data('slug') !== '' ? params.additional.varumarke = selectedFactory.data('slug') : false;
        sort.length > 0 && sort.data('slug') !== '' ? params.additional.sort = sort.data('slug') : false;


        if (loadMore) {
            currentPage === '' ? currentPage = 2 : currentPage++;
            $('.products__container').data('page', currentPage);
            params.additional.page = currentPage;
        } else {
            $('.products__container').data('page', 1);
        }
        return params;
    }

    function buildUrl(params) {
        var prefix = '';
        var suffix = '';

        // I  could use loop here but I want exactly that order of main parameters
        if (params.main.category) {
            prefix += '/' + params.main.category;
        }
        if (params.main.material) {
            prefix += '/' + params.main.material;
        }
        if (params.main.type) {
            prefix += '/' + params.main.type;
        }
        if (params.main.glass) {
            prefix += '/' + params.main.glass;
        }
        if (params.main.page) {
            prefix += '/' + params.main.page;
        }

        for (var param in params.additional) {
            suffix += '&' + param + '=' + params.additional[param];
        }

        if (suffix !== '') {
            suffix = '?' + suffix.substr(1);
        }

        return prefix + suffix;
    }

})()
